/**
 * @fileoverview 下载接口
 * @filetype ES6
 * @author zhenn
 */
import '../css/reset.css';
import '../css/download.css';
import 'babel-polyfill';
import Popover from 'antd-mobile/lib/popover';
import 'antd-mobile/lib/popover/style/css';
import FastClick from 'c-fastclick';
import React, {Component} from 'react';
import ReactDOM, {render} from 'react-dom';
import SwipeSlide from 'c-slide';
import url from 'c-url';
import lang from './lang/index';
import OpenBrowserPop from './pop/pop-openbrowser';
import { preload } from './lib/preload';
preload();

const Item = Popover.Item;

FastClick.attach(document.body);

let Download = class extends Component {

    static defaultProps = {
        bannerList: [],
        selectIndex: 0 // 默认第一项，索引值0
    };

    constructor(props) {
        super(props);

        this.state = {
            language: "pics-text",
            langType: lang.langType,
            visible: false
        }

        this.LANG_CONFIG = {
            "zhcn": {
                option: '简体中文',
                text: '简体中文'
            },
            "zhtw": {
                option: '繁體中文(台灣)&lrm;',
                text: '繁體中文(台灣)',
            },
            "zhhk": {
                option: '繁體中文(香港)&lrm;',
                text: '繁體中文(香港)'
            },
            "enus": {
                option: 'English',
                text: 'English'
            },
            "vivn": {
                option: 'Tiếng Việt',
                text: 'Tiếng Việt'
            },
            "areg": {
                option: 'العَرَبِيَّة',
                text: 'العَرَبِيَّة'
            },
            'jajp': {
                option: '日本語',
                text: '日本語'
            },
            'idid': {
                option: "Bahasa Indonesia",
                text: "Bahasa Indonesia"
            }
        };

    }

    componentWillMount() {
        this.initCSS();
    }

    componentWillUnmount() {
        this.swipeSlide = null;
    }

    componentDidMount() {
        let self = this;
        this.download();


        // 图片轮播
        if (this.props.bannerList.length == 1) {
            $(".dot").hide();
        } else {
            this.swipeSlide = new SwipeSlide($(this.refs.content), {
                continuousScroll: true,
                autoSwipe: true,
                speed: 3000,
                transitionType: 'ease-in',
                callback: function (index) {
                    if (!self.swipeSlide) {
                        return;
                    }
                    self.setState({
                        selectIndex: index
                    });
                }
            });
        }

    }


    query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || 'search',
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    k

    getSystem() {
        var ua = navigator.userAgent;
        return /(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc';
    }

    getPlatform() {
        let [ua, pl] = [navigator.userAgent, 'other'];

        if (ua.match(/uplive/i) || this.query('pl', 'hash') == 'uplive' || localStorage.getItem('__inuplive__') || this.query('pl') == 'uplive'){
            pl = 'uplive';
        } else if (ua.match(/micromessenger/i)) {
            pl = 'wechat';
        } else if (ua.match(/qq\//i)) {
            pl = 'qq';
        } else if (ua.match(/weibo/i)) {
            pl = 'weibo';
        } else if (ua.match(/renren/i)) {
            pl = 'renren';
        } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
            pl = 'fb';
        } else if (ua.match(/Line/i)) {
            pl = 'line';
        } else if (ua.match(/[Tt]witter/i)) {
            // twitter
            pl = 'twitter';
        } else if (ua.match(/KAKAOTALK/i)) {
            pl = 'kakao';
        } else if (ua.match(/Instagram/i)) {
            pl = 'instagram';
        } else if (ua.match(/Messenger/i)) {
            pl = 'messenger';
        }

        return pl;
    }

    download = () => {

        let url = this.downloadUrl();
        let needMiddleLoadApp = ['weibo','line','wechat','qq'];
        let onlyAndroidNeedMiddleLoadApp = ['kakao','twitter'];
        //判断平台 决定是下载还是弹框
        let platform = this.getPlatform();
        let system = this.getSystem();
        if(needMiddleLoadApp.indexOf(platform) > -1){
            new OpenBrowserPop({content:lang.template('点击右上角选择浏览器打开')}).create();
            return;
        }
        if(system == 'android' && onlyAndroidNeedMiddleLoadApp.indexOf(platform) > -1){
            new OpenBrowserPop({content:lang.template('点击右上角选择浏览器打开')}).create();
            return;
        }
        window.location.href = url;
       
    }
    downloadUrl = ()=>{
        //香港铜锣湾地铁线下广告  安卓&ios：https://app.adjust.com/c4a7krt_go6kbdp
        //singing for the world 专属下载的二维码 https://app.adjust.com/vhpkjq6_r0nikp2

        let download = {
            'singing': 'https://app.adjust.com/vhpkjq6_r0nikp2',
            'tongluowan': 'https://app.adjust.com/c4a7krt_go6kbdp'
        };
        let res = url.query('res') || 'tongluowan';
        return download[res];
    }

    changeLang = (type) => {


        this.setState({
            langType: lang.langType
        });

        this.initCSS();
    };

    initCSS() {
        if (['zhcn', 'zhtw', 'zhhk'].indexOf(lang.langType) > -1) {
            this.setState({
                language: "pics-text"
            });
        } else {
            this.setState({
                language: "pics-text en"
            });
        }
    }

    handleVisibleChange = (visible) => {
        this.setState({
            visible,
        });
    }

    onSelect = (opt) => {
        let type = opt.props.value;

        lang.init(type);

        this.setState({
            visible: false,
            langType: type
        });

        this.initCSS();
    };

    goUplive = () => {
        let self = this;
        let pl = self.getPlatform();
        let _url = 'https://h5.upliveapp.com/uppro/index.html';

        location.href = _url;
    }

    render() {
        let self = this;
        let res = self.query('res') || '';

        let Arr = ['slide1', 'slide2', 'slide3', 'slide4'];
        let picLine = [0, 0, 0, 0];
        let pics = [0, 0, 0, 0];


        const {language, langType, selected, visible} = this.state;
        let curLanuage = this.LANG_CONFIG[langType] ? this.LANG_CONFIG[langType].text : this.LANG_CONFIG['enus'].text;

        let $menu = (
            <div>
                {
                    ['zhcn', 'zhtw', 'zhhk', 'enus', 'jajp', 'vivn', 'idid', 'areg'].map((item, index) => {
                        let config = this.LANG_CONFIG[item];
                        return (
                            <Item value={item} key={index}
                                  className={langType == item ? 'selected' : ''}>{config.text}</Item>
                        );
                    })
                }
            </div>
        );

        return (
            <div>
                <div className="logo"></div>
                <div className="title"></div>
                <div className="banner-slide-wrap" ref="content">

                    <ul className="slide-list">
                        {
                            Arr.map((item,index) => {
                                return <li className={'slide-item ' + item} key={index}> 
                                    <img className="b-banner" src={require('../images/' + item + '.png')}/>
                                </li>
                            })
                        }
                    </ul>

                    <Popover overlay={$menu} visible={visible}
                             onVisibleChange={this.handleVisibleChange}
                             onSelect={this.onSelect} placement={langType == 'areg' ? 'bottomLeft' : 'bottomRight'}
                             overlayClassName="lang-pop">
                        <div className="lang-select">{curLanuage}</div>
                    </Popover>
                    {
                        document.domain != 'www.xingyunzhi.cn' ? (

                            <div>
                                <div className="slide-btn1" onClick={self.goUplive}>{lang.template('立即观看直播')}</div>
                                <div className="slide-btn2" onClick={self.download}>{lang.template('立即下载Uplive')}</div>
                            </div>
                        ) : null
                    }

                </div>
                <h1 className={language}>{lang.template('全球嗨翻 实时互动')}</h1>
                <div className="pics">
                    {
                        picLine.map((item, i) => {
                            return <ul>
                                {
                                    pics.map((item, j) => {
                                        var m = i * 4 + j;
                                        return <li key={j}>
                                            <img className="origin-pic" src={require('../images/pics1/' + m + '.png')}/>
                                            <img className="stack-pic" src={require('../images/pics2/' + m + '.png')}/>

                                        </li>
                                    })
                                }
                            </ul>
                        })
                    }
                </div>
                <div className="footer">Copyright © 2018 @ All Rights Reserved Asia Innovations Group Limited</div>
            </div>
        );


    }

}

render(<Download/>, $('#wrap')[0]);





// WEBPACK FOOTER //
// ./js/app.js